import View from '../../core/View';
import SimpleToolbarView from "../SimpleToolbarView";
import URLUtils from "../../util/URLUtils";

export default class HTMLView extends View {

    createView(model) {

        let baseUrl = model['baseUrl'];
        let libraryCatalog = model['libraryCatalog'];
        let visualTemplate = model['visualTemplate'];

        let libraryDOM = $('<div>', {
            class: 'web-view',
            css: {
                'background-color': 'white'//visualTemplate.listCatalogsBackgroundColor
            }
        });

        if (libraryCatalog.showCatalogMenu) {
            this.app.createView(new SimpleToolbarView(), {
                'libraryCatalog': libraryCatalog,
                'visualTemplate': visualTemplate
            }).appendTo(libraryDOM);
        }

        let iframeContainer = $('<div>', {
            class: 'iframe-container'
        }).appendTo(libraryDOM);

        $('<iframe>', {
            'src': URLUtils.getURL(baseUrl + libraryCatalog.path) + '/index.html'
        }).appendTo(iframeContainer);

        return libraryDOM;

    }

}
